import type { ListenerEffectAPI } from "@reduxjs/toolkit";
import { isAnyOf } from "@reduxjs/toolkit";
import {
  addStorageObject,
  attachChildToParent,
} from "../../../../../app/state/storageObjectSlice/actions/actions";
import type { AddStorageObjectFulfilled } from "../../../../../app/state/storageObjectSlice/types";
import type { AppDispatch, RootState } from "../../../types";
import { appListenerMiddleware } from "../../appListenerMiddleware";
import { serviceHandlers } from "../handlers/storageHandlers";
import { StorageScope } from "../../../../api/instances/storageApi/types/service_types";
import { storageObjectParentReset } from "../../../../../app/state/storageObjectSlice/slice";

export function createStorageListener() {
  appListenerMiddleware.startListening({
    matcher: isAnyOf(addStorageObject.fulfilled),
    effect: async (action: AddStorageObjectFulfilled, listenerApi) => {
      const normalized = action.payload;
      const service = action.meta.arg.service as StorageScope;
      const meta = action.meta;

      if (normalized?.parentId) {
        const result = await listenerApi.dispatch(
          attachChildToParent({
            childIds: [normalized.id],
            parentId: normalized.parentId,
            service,
          }),
        );

        if (attachChildToParent.rejected.match(result)) {
          listenerApi.dispatch(
            storageObjectParentReset({
              service,
              id: normalized.id,
              parentId: normalized.parentId,
            }),
          );
        }
      }

      const handler = serviceHandlers[service];
      if (meta.arg.skipCreateListener) return;
      if (handler?.onCreate && normalized) {
        await handler.onCreate(
          listenerApi as ListenerEffectAPI<RootState, AppDispatch>,
          normalized,
          action.meta as AddStorageObjectFulfilled["meta"],
        );
      }
    },
  });
}
